export default __webpack_public_path__ + "static/media/mastercard.cf61e1a0.svg";